import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setOpen((prev) => !prev);
    document.body.classList.toggle("nav-mobile-open", !open);
  };

  const closeMenu = () => {
    setOpen(false);
    document.body.classList.remove("nav-mobile-open");
  };

  useEffect(() => {
    const onScroll = () => setScrolled((window.scrollY || 0) > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("nav-scrolled", scrolled);
    return () => document.body.classList.remove("nav-scrolled");
  }, [scrolled]);

  return (
    <header className={`ep-header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="ep-container">
        {/* Logo (left) */}
        <Link
          to="/"
          className="ep-brand"
          onClick={closeMenu}
          aria-label="Home"
        >
          <img
            src={`${process.env.PUBLIC_URL}/emeraldtext.png`}
            alt="Emerald Appraisal Services logo"
            width="228"
            height="228"
            decoding="async"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="ep-nav" aria-label="Primary">
          <Link to="/" className="ep-link" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/about" className="ep-link" onClick={closeMenu}>
            About&nbsp;Us
          </Link>
          <Link to="/how-it-works" className="ep-link" onClick={closeMenu}>
            How&nbsp;It&nbsp;Works
          </Link>
          <Link to="/pricing" className="ep-link" onClick={closeMenu}>
            Pricing
          </Link>
          <Link to="/contact" className="ep-link" onClick={closeMenu}>
            Contact&nbsp;Us
          </Link>
        </nav>

        {/* Mobile hamburger (right) */}
        <button
          className={`ep-hamburger ${open ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          type="button"
        >
          <span className="ep-hamburger-box">
            <span className="ep-hamburger-inner" />
          </span>
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={`ep-mobile ${open ? "open" : ""}`}>
        <nav className="ep-mobile-list" aria-label="Mobile">
          <Link to="/" className="ep-mobile-link" onClick={closeMenu}>
            <span>Home</span>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              <path
                d="M1 6H11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 1L11 6L6 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </Link>

          <Link to="/about" className="ep-mobile-link" onClick={closeMenu}>
            <span>About Us</span>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              <path
                d="M1 6H11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 1L11 6L6 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </Link>

          <Link
            to="/how-it-works"
            className="ep-mobile-link"
            onClick={closeMenu}
          >
            <span>How It Works</span>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              <path
                d="M1 6H11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 1L11 6L6 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </Link>

          <Link to="/pricing" className="ep-mobile-link" onClick={closeMenu}>
            <span>Pricing</span>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              <path
                d="M1 6H11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 1L11 6L6 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </Link>

          <Link to="/contact" className="ep-mobile-link" onClick={closeMenu}>
            <span>Contact Us</span>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              <path
                d="M1 6H11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 1L11 6L6 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </Link>
        </nav>
      </div>
    </header>
  );
}
